import onOutOfView from 'core/DOM/onOutOfView'
import toggleClass from 'utils/DOM/toggleClass'
import getById from 'utils/DOM/getById'

function stickySummary() {
  const summary = getById('plan-summary')
  const mainContent = $('.twoColumns__main')
  const container = $('.twoColumns__aside')
  let lastPosition
  let lastIsOverScroll

  onOutOfView('plan-summary', obj => {
    if (mainContent.height() - summary.clientHeight > 100) {
      const heightElement = $(summary).outerHeight(true)

      const bottomContainer = container.position().top + container.outerHeight(true)
      const maxScroll = bottomContainer - heightElement

      if (lastPosition !== obj.scrollReachElement) {
        lastPosition = obj.scrollReachElement
        toggleClass(summary, 'sticky', lastPosition)
        summary.style.width = lastPosition ? `${container.width()}px` : 'auto'
      }

      const isOverScroll = obj.lastKnownScrollPosition >= maxScroll
      if (lastIsOverScroll !== isOverScroll) {
        lastIsOverScroll = isOverScroll
        toggleClass(summary, 'sticky-absolute', isOverScroll)
      }
    }
  })
}

export default stickySummary
